import { Map } from 'immutable';

export default function getDefaultStatusId(state: any) {
  return state
    .getIn(['status', 'data', 'byId'], Map())
    .findKey((status: any) => status.get('isDefault'));
}
